import Crud from '../views/Cbo/Crud'
import Entity from '../views/Cbo/Add'

let routes = {
    path: '/cbos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cbos/add',
            name: 'NewCbo',
            component: Entity,
            meta: {
                pageTitle: 'cbo.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'cbo.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cbos/edit/:id?',
            name: 'EditCbo',
            component: Entity,
            meta: {
                pageTitle: 'cbo.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'cbo.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cbos',
            name: 'list-cbos',
            component: Crud,
            meta: {
                pageTitle: 'cbo.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'cbo.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
